import Text from "@/components/common/Typography/Text";
import { Card, CardProps, Row } from "antd";

type UnsupportedDealItemProps = Omit<CardProps, "styles"> & {
  productType?: string;
  styles?: any;
};

const UnsupportedDealItem = ({ productType, className, ...props }: UnsupportedDealItemProps) => {
  return (
    <Card
      className={`${className ? `${className} ` : ""}home__deals-hotels--item`}
      style={{
        width: '100%',
        minHeight: '100%',
        overflow: 'hidden'
      }}
      styles={{
        ...props.styles,
        body: {
          padding: "1.2rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "34.4rem",
          ...props.styles?.body,
        },
      }}
      {...props}
    >
      <Row justify="center">
        <Text type="secondary" style={{ textAlign: "center" }}>
          {`Sản phẩm ${productType || ""} chưa được hỗ trợ`}
        </Text>
      </Row>
    </Card>
  );
};

export default UnsupportedDealItem
